import React, { useState } from 'react';
import LandingNav from './landing/LandingNav';
import FooterSection from './landing/FooterSection';
import LandingLoginModal from './landing/LandingLoginModal';
import LandingForgotModal from './landing/LandingForgotModal';
import LandingRegisterModal from './landing/LandingRegisterModal';

/**
 * Shared layout for public pages (Privacy Policy, Terms, Trust Center).
 * Provides the full site nav with Sign In / Get Started + auth modals.
 */
const PublicPageLayout = ({ children }) => {
  const [showLoginModal, setShowLoginModal] = useState(false);
  const [showRegisterModal, setShowRegisterModal] = useState(false);
  const [showForgotModal, setShowForgotModal] = useState(false);

  const openLogin = () => {
    setShowRegisterModal(false);
    setShowForgotModal(false);
    setShowLoginModal(true);
  };
  const openRegister = () => {
    setShowLoginModal(false);
    setShowForgotModal(false);
    setShowRegisterModal(true);
  };
  const openForgot = () => {
    setShowLoginModal(false);
    setShowRegisterModal(false);
    setShowForgotModal(true);
  };

  return (
    <>
      <LandingNav onLoginClick={openLogin} onRegisterClick={openRegister} />

      {children}

      <FooterSection />

      <LandingLoginModal
        open={showLoginModal}
        onOpenChange={setShowLoginModal}
        onForgotClick={openForgot}
        onRegisterClick={openRegister}
      />
      <LandingForgotModal
        open={showForgotModal}
        onOpenChange={setShowForgotModal}
        onLoginClick={openLogin}
      />
      <LandingRegisterModal
        open={showRegisterModal}
        onOpenChange={setShowRegisterModal}
        onLoginClick={openLogin}
      />
    </>
  );
};

export default PublicPageLayout;
